// ANGULAR DEPENDANCY
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// EXTERNAL DEPENDANCY
import { Observable } from 'rxjs';

// SERVICES
import { ApiConfigService } from '../../../core/services/api-config/api-config.service';
import { BaseService } from '../../../core/services/base/base.service';
import { TokenStorageService } from '../../../core/services/token-storage/token-storage.service';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';
import { ApiResponse } from '../../../../models/common/api/api-response.interface';

// COMMON UTILS
import { APIUtil } from '../../../../core/utils/api-util';

// CONSTANTS
import { MASTER_BUSINESS_API_URL } from '../../../../constants/api/master-business';


/**
 * This service is for MasterBusinessService api calls
 * For handle MasterBusinessService api calls
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 27/04/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>) initially created MasterBusinessService
 */
@Injectable()
export class MasterBusinessService extends BaseService {

  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService) {
    super(httpClient, tokenStorage);
  }

  /**
     * MasterBusiness common master api
     * @param payload : Api common payload object
     * @returns Observable<ApiResponse>
     */
  public masterBusinessCommon(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['type'];
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL[payload.data.type]}`, replaceParams, payload);

    return this.post(url, payload.data);
  }

  //////////////////////// PUBLIC HOLIDAY START///////////////////////////
  /**
   * MasterBusiness get all public holiday
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getPublicHolidayAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_PUBLIC_HOLIDAY_ALL}`;
    return this.post(url, payload);
  }

  /**
   * MasterBusiness get public holiday by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getPublicHolidayPagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_PUBLIC_HOLIDAY_PAGING}`;
    return this.post(url, payload);
  }


  /**
  * MasterBusiness get public holiday by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getPublicHoliday(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['public_holiday_id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_PUBLIC_HOLIDAY}`, replaceParams, payload);
    return this.get(url);
  }

  /**
    * MasterBusiness add public holiday
    * @param payload : Api  payload object
    * @returns Observable<ApiResponse>
    */
  public addPublicHoliday(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.ADD_PUBLIC_HOLIDAY}`;
    return this.post(url, payload);
  }

  /**
  * MasterBusiness update public holiday
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public updatePublicHoliday(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.ADD_PUBLIC_HOLIDAY}`;
    return this.put(url, payload);
  }

  /**
  * MasterBusiness get public holiday
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public deletePublicHoliday(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['public_holiday_id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_PUBLIC_HOLIDAY}`, replaceParams, payload);
    return this.delete(url);
  }
  //////////////////////// PUBLIC HOLIDAY END ///////////////////////////

  //////////////////////// TRAINING LICENSE START ////////////////////////
  /**
  * MasterBusiness get all training license
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getTrainingLicenseAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_TRAINING_LICENSE_ALL}`;
    return this.post(url, payload);
  }

  /**
  * MasterBusiness get training license by pagging
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getTrainingLicensePagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_TRAINING_LICENSE_PAGING}`;
    return this.post(url, payload);
  }

  /**
  * MasterBusiness get training license by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getTrainingLicense(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['training_licence_id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_TRAINING_LICENSE}`, replaceParams, payload);
    return this.get(url);
  }

  /**
  * MasterBusiness add training license
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public addTrainingLicense(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.ADD_TRAINING_LICENSE}`;
    return this.post(url, payload);
  }

  /**
   * MasterBusiness update training license
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public updateTrainingLicense(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.ADD_TRAINING_LICENSE}`;
    return this.put(url, payload);
  }

  /**
    * MasterBusiness get training license
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public deleteTrainingLicense(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['training_licence_id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_TRAINING_LICENSE}`, replaceParams, payload);
    return this.delete(url);
  }
  //////////////////////// TRAINING LICENSE END ////////////////////////

  //////////////////////// STRESS PROFILE START ////////////////////////
  /**
 * MasterBusiness get stress profile all
 * @param payload : Api common payload object
 * @returns Observable<ApiResponse>
 */
  public getStressProfileAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_STRESS_PROFILE_ALL}`;
    return this.post(url, payload);
  }

  /**
  * MasterBusiness get stress profile by pagging
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getStressProfilePagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_STRESS_PROFILE_PAGING}`;
    return this.post(url, payload);
  }

  /**
   * MasterBusiness Get stress profile lookup
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getStressProfileLookUp(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_STRESS_PROFILE_LOOKUP}`;
    return this.get(url);
  }

  /**
  * MasterBusiness get stress profile by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getStressProfile(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['business_stress_profile_id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_STRESS_PROFILE}`, replaceParams, payload);

    return this.get(url);
  }

  /**
    * MasterBusiness add stress profile
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public addStressProfile(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.ADD_STRESS_PROFILE}`;
    return this.post(url, payload);
  }

  /**
    * MasterBusiness update stress profile
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public updateStressProfile(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.ADD_STRESS_PROFILE}`;
    return this.put(url, payload);
  }

  /**
    * MasterBusiness delete stress profile
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public deleteStressProfile(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['business_stress_profile_id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_STRESS_PROFILE}`, replaceParams, payload);
    return this.delete(url);
  }
  //////////////////////// STRESS PROFILE END ////////////////////////

  //////////////////////// LEAVE START ///////////////////////////////

  /**
    * MasterBusiness get leave all
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public getLeaveAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_LEAVE_ALL}`;
    return this.post(url, payload);
  }

  /**
    * MasterBusiness get leave by pagging
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public getLeavePagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_LEAVE_PAGING}`;
    return this.post(url, payload);
  }

  /**
    * Get stress profile list
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public getMasterLeaveLookup(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_LEAVE_LOOKUP}`;
    return this.get(url);
  }
  /**
    * MasterBusiness get leave
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public getLeave(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['leave_id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_LEAVE}`, replaceParams, payload);
    return this.get(url);
  }

  /**
    * MasterBusiness add leave
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public addLeave(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.ADD_LEAVE}`;
    return this.post(url, payload);
  }

  /**
    * MasterBusiness update leave
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public updateLeave(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.ADD_LEAVE}`;
    return this.put(url, payload);
  }

  /**
    * MasterBusiness get leave
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public deleteLeave(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['leave_id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_LEAVE}`, replaceParams, payload);
    return this.delete(url);
  }
  //////////////////////// LEAVE END ///////////////////////////////

  //////////////////////// EMPLOYEE ROLE START///////////////////////
  /**
   * Get employee role list
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getEmployeeRoleList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.EMPLOYEE_ROLE_LOOKUP}`;

    return this.get(url);
  }
  //////////////////////// EMPLOYEE ROLE END///////////////////////

  //////////////////////// BUSINESS ROLE START///////////////////////

  /**
   * MasterBusiness get business role by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getBusinessRolePaging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_BUSINESS_ROLE_PAGING}`;
    return this.post(url, payload);
  }
   /**
   * MasterBusiness get business role by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public dailyReportPaging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.DAILY_REPORT_PAGING}`;
    return this.post(url, payload);
  }

  /**
   * MasterBusiness get all Business Roles
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getBusinessRoleAll(payload: ApiPayload) {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_BUSINESS_ROLE_ALL}`;
    return this.get(url);
  }

  /**
   * MasterBusiness get business role by id
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getBusinessrole(payload: ApiPayload) {
    const replaceParams = ['business_role_id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.GET_BUSINESS_ROLE}`, replaceParams, payload);

    return this.get(url);
  }

  /**
    * MasterBusiness update business-role
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public updateBusinessRole(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.BUSINESS_ROLE}`;
    return this.put(url, payload);
  }

  /**
     * MasterBusiness add public holiday
     * @param payload : Api  payload object
     * @returns Observable<ApiResponse>
     */
  public addBusinessRole(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.BUSINESS_ROLE}`;
    return this.post(url, payload);
  }

  //////////////////////// BUSINESS ROLE END///////////////////////

  public logPaging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.LOG_PAGING}`;
    return this.post(url, payload);
  }

  public logExport(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.LOG_EXPORT}`;
    return this.post(url, payload);
  }

  public serverLogPaging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.SERVER_LOG_PAGING}`;
    return this.post(url, payload);
  }

  public serverLogExport(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.SERVER_LOG_EXPORT}`;
    return this.post(url, payload);
  }


  public notificationPaging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.NOTIFICATION_PAGING}`;
    return this.post(url, payload);
  }

  public notificationExport(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.NOTIFICATION_EXPORT}`;
    return this.post(url, payload);
  }

  public emailPaging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.EMAIL_LOG_PAGING}`;
    return this.post(url, payload);
  }

  public emailExport(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_BUSINESS_API_URL.EMAIL_LOG_EXPORT}`;
    return this.post(url, payload);
  }
}

